export default {"src":"/_next/static/media/patches.7e97f6eb.svg","height":44,"width":47,"blurWidth":0,"blurHeight":0};